const TILE_TONES = {
  slate: 'bg-surface text-fg ring-line/15',
  info: 'bg-accent/10 text-accent ring-accent/20',
  success: 'bg-success-soft/15 text-success-soft-fg ring-success-soft/25',
} as const;

/** One at-a-glance scoreboard tile for the station header row. */
export function StatTile({
  label,
  value,
  tone,
}: {
  label: string;
  value: number;
  tone: keyof typeof TILE_TONES;
}) {
  return (
    <div className={`rounded-token-lg px-4 py-3 shadow-token-sm ring-1 ${TILE_TONES[tone]}`}>
      <div className="text-[11px] font-semibold uppercase tracking-wider opacity-75">{label}</div>
      <div className="mt-0.5 text-2xl font-semibold tabular-nums">{value}</div>
    </div>
  );
}
